/**
 * Copyright 2017 Control4 Corporation. All rights reserved.
 * Control4 Confidential and Proprietary Information.
 */

import { provideStore } from '@ngrx/store';

import { CORE_STORE } from '@c4/core';
import { AUTH_REDUCERS } from '@c4/auth';

import { COMMON_PROGRAMMING_REDUCERS } from './common/common.stores';
import { QUICKSTART_PROGRAMMING_REDUCERS } from './quickstarts/quickstarts.stores';
import { ADVANCED_PROGRAMMING_REDUCERS } from './advanced/advanced.stores';

export const PROGRAMMING_REDUCERS: any = Object.assign({},
  CORE_STORE,
  AUTH_REDUCERS,
  ADVANCED_PROGRAMMING_REDUCERS,
  QUICKSTART_PROGRAMMING_REDUCERS,
  COMMON_PROGRAMMING_REDUCERS
);

// export const PROGRAMING_STORE_PROVIDER: Array<any> = provideStore(PROGRAMMING_REDUCERS);



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/programming.stores.ts